import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

interface ServiceContractFlagProps {
	label: string;
	description: string;
	value?: boolean;
}

export const ServiceContractFlag = ({
	label,
	description,
	value = false,
}: ServiceContractFlagProps) => {
	const { t } = useTranslation('commonButton');

	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'flex-start',
				gap: 4,
			}}>
			<Box>
				<Typography sx={{ color: 'grey.700', fontSize: '1.125rem' }}>
					{label}
				</Typography>
				<Typography
					variant="body2"
					sx={{
						color: 'text.secondary',
					}}>
					{description}
				</Typography>
			</Box>
			<FormControlLabel
				disabled
				sx={{
					flexShrink: 0,
					minWidth: 100,
					'.MuiFormControlLabel-label.Mui-disabled': {
						color: 'text.primary',
					},
				}}
				control={
					<Switch
						checked={value}
						slotProps={{ input: { 'aria-label': label } }}
					/>
				}
				label={value ? t('yes') : t('no')}
			/>
		</Box>
	);
};
